'use strict';

angular.module('app.entity.audit')
    .component('auditListItem', {
        templateUrl: 'modules/ecrd/components/audit/components/audit-list-item.template.html',
        bindings: {
            item: '<',
            showReason: '<',
        },
        controller: [
            'CrdConfigurationService',
            'CrfService',
            'RecordDataService',
            function AuditListItemComponent(CrdConfigurationService, CrfService, RecordDataService) {
                var vm = this;

                // La lista original de cambios del ítem con propiedades adicionales interesantes para este listado
                vm.changes = [];

                vm.$onInit = function() {
                    extendChanges();
                };

                function extendChanges() {
                    vm.changes = vm.item.change.reduce(function(acc, change) {
                        var changeData = extendChange(change);

                        return changeData ? acc.concat(changeData) : acc;
                    }, []);
                }

                function extendChange(change) {
                    if (!isValidChange(change)) {
                        return undefined;
                    }

                    var extended = angular.copy(change);

                    var format = getChangeFormat(change);
                    if (format) {
                        extended.format = format;
                    }
                    // Lista de acciones que tienen que ver con un elemento concreto
                    var itemActions = ['form-metadata', 'modify-data', 'delete', 'add-data', 'add-item', 'delete-item'];
                    if (itemActions.indexOf(change.action) > -1) {
                        angular.extend(extended, getElementProperties(change));
                    }

                    return extended;
                }

                function getElementProperties(change) {
                    var properties = {};

                    if (change.uid) {
                        // se trata de un cambio asociado a un elemento del CRD identificado por su UID
                        properties.fieldUId = angular.isArray(change.uid) ? change.uid.join('.') : change.uid;
                        var element = CrfService.getElementByUID(change.uid);
                        if (element !== null) {
                            properties.fieldName = element.getName();
                            properties.fieldId = element.getId();

                            var newLabel = RecordDataService.getElementFullLabeledPathByUID(change.uid);
                            var itemExists = RecordDataService.isElementValid(change.uid);

                            if (change.flag && change.flag !== 'locked') { // si tiene un estado de aprobación
                                var state = CrdConfigurationService.getStates().getState(change.flag);
                                if (state && newLabel) { // GARU-4401
                                    newLabel.push(state.getName());
                                }
                            }

                            if (element.isList()) {
                                properties.elementChanged = itemExists && !sameLabel(change.label, newLabel);
                                if (['delete', 'delete-item', 'add-item'].indexOf(change.action) > -1) {
                                    // campo que pertenece a un ítem de lista, y que además ese ítem de lista se
                                    // ha eliminado de los datos
                                    properties.itemDeleted = !itemExists;
                                }
                            } else {
                                if (itemExists) {
                                    // si la acción es un metadata de un formulario, el label incluye el último
                                    // componente, que describe el flag (p.ej. "Estado del formulario"). Al ser estados
                                    // configurables ese texto puede cambiar y ser relevante
                                    properties.elementChanged = !sameLabel(change.label, newLabel);
                                } else {
                                    // campo que pertenece a un ítem de lista, y que además ese ítem de lista se
                                    // ha eliminado de los datos
                                    properties.itemDeleted = true;
                                }
                            }
                            if (properties.elementChanged) {
                                properties.newLabel = newLabel;
                            }
                        } else {
                            // campo que ya no existe en el CRF
                            // esto no señala campos dentro de ítems de listas que se hayan borrado
                            var uidArray = angular.isArray(change.uid) ? change.uid : change.uid.split('.');
                            properties.fieldId = uidArray[uidArray.length - 1];
                            properties.elementDeleted = true;
                        }
                    } else {
                        properties.fieldUId = 'empty';
                        // se trata de un cambio no asociado a un elemento
                        // (p.ej. cambio de ID de record manual, etc.)
                        if (change.uid === null && angular.isArray(change.label) && change.label.length === 0) {
                            // GARU-3285 Audit log mal formateado, es un cambio de ID de paciente (ya que es el
                            // único cambio posible fuera de datos y metadatos)
                            properties.label = ['ID ' + CrdConfigurationService.getLabelSingular()];
                        }
                    }

                    return properties;
                }

                function isValidChange(change) {
                    if (['global-metadata', 'form-metadata'].indexOf(change.action) === -1) {
                        return true;
                    }

                    // Si el cambio es de falsey a falsey no tiene sentido presentarlo
                    // Se quita aquí a falta de limpiarlo en los datos
                    return !!change.before || !!change.after;
                }

                function getChangeFormat(change) {
                    if (['global-metadata', 'form-metadata'].indexOf(change.action) > -1) {
                        return 'metadata';
                    }

                    if (change.action === 'store-record') {
                        return 'store';
                    }

                    // GARU-4582 Identificamos los campos de tipo lista de ficheros
                    if (seemsFieldFilesChange(change)) {
                        return change.type === 'dicom' ? 'dicom' : 'fieldfiles';
                    }

                    // No hay formato específico
                    return null;
                }

                function seemsFieldFilesChange(change) {
                    // aceptamos cambios de undefined a array y de array a undefined
                    var valueBefore = angular.isDefined(change.before) ? change.before : [];
                    var valueAfter = angular.isDefined(change.after) ? change.after : [];

                    if (!angular.isArray(valueBefore) || !angular.isArray(valueAfter)) {
                        return false;
                    }

                    var allValues = valueBefore.concat(valueAfter);

                    return allValues.length > 0 && allValues.every(function(value) {
                        return angular.isDefined(value.filename);
                    });
                }

                /**
                 * Determina si las dos etiquetas son iguales. Los índices numéricos que puedan aparecer en cualquier
                 * componente, los trata igual sean cadenas de texto o números enteros
                 *
                 * @param  {array} labelA   Primera etiqueta a comparar
                 * @param  {array} labelB   Segunda etiqueta a comparar
                 *
                 * @return {boolean}        TRUE si son iguales
                 */
                function sameLabel(labelA, labelB) {
                    if (angular.isArray(labelA) && angular.isArray(labelB)) {
                        if (labelA.length === labelB.length) {
                            var index;
                            for (index = 0; index < labelA.length; index++) {
                                if (String(labelA[index]) !== String(labelB[index])) {
                                    return false;
                                }
                            }

                            return true;
                        }
                    }

                    return false;
                }
            },
        ],
    });
